export const init = async (
  sendAndWaitWs,
  type,
  chatId = null,
  debug = false,
  force = false
) => {
  const response = await sendAndWaitWs(
    "/assistant/init",
    JSON.stringify({
      type,
      chatId,
      debug,
      force,
      sideData: {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        locationSymbol: "Local",
      },
    })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const ackServiceMessage = async (
  sendAndWaitWs,
  chatId,
  queryId,
  message,
  forceInit
) => {
  const response = await sendAndWaitWs(
    "/assistant/ackServiceMessage",
    JSON.stringify({
      chatId,
      queryId,
      text: message.text,
      textMode: message.textMode,
      force: forceInit,
      sideData: {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        locationSymbol: "Local",
      },
    })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getEntityTypes = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs(
    "/assistant/listEntityTypes",
    JSON.stringify({})
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);

  // Convert Map<String, String> to array of objects
  if (result.types && typeof result.types === "object") {
    return Object.entries(result.types).map(([type, typeName]) => ({
      type,
      typeName,
    }));
  }
  return [];
};

export const getEntities = async (sendAndWaitWs, entityType) => {
  const response = await sendAndWaitWs(
    "/assistant/listEntities",
    JSON.stringify({ type: entityType, input: "" })
  );
  if (response.error) {
    return response.error;
  }
  const result = JSON.parse(response.payload);
  return Array.isArray(result.entities) ? result.entities : [];
};

export const query = async (
  sendAndWaitWs,
  chatId,
  queryId,
  userQuery,
  debug = false
) => {
  const response = await sendAndWaitWs(
    "/assistant/query",
    JSON.stringify({
      chatId,
      queryId,
      userQuery,
      debug,
    })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const stop = async (sendAndWaitWs, queryId) => {
  const response = await sendAndWaitWs(
    "/assistant/stop",
    JSON.stringify({ queryId })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const checkScript = async (sendAndWaitWs, scriptId) => {
  const response = await sendAndWaitWs(
    "/assistant/checkScript",
    JSON.stringify({ scriptId })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
